import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UserDetails from "./UserDetails";
import AssignedForm from "./AssignedForm";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import CardsBorder from "../../../../../components/Cards/CardsBorder";
import { IoArrowBackCircleOutline } from "react-icons/io5";

const UserDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const { userId, projectPage } = location.state || {};
  const { userId, projectPage, source } = location.state || {};
  const [formAllotments, setFormAllotments] = useState([]);
  console.log(projectPage, "projectpage");
  const handleUserDataReceived = (data) => {
    setFormAllotments(data?.formAllotments || []);
  };

  // const handleBackNavigation = () => {
  //   if (source === "assign-form") {
  //     // Navigate back to the assign form page
  //     navigate(-1); // Go back to previous page
  //   }
  //   if (source === "user-form") {
  //     navigate("/organization/projects/projectPage");
  //   } else {
  //     navigate("/organization/user-management");
  //   }
  // };
  const handleBackNavigation = () => {
    if (source === "assign-form") {
      // Navigate back to the assign form page
      navigate(-1); // Go back to previous page
    } else if (source === "user-form") {
      navigate(-1);
    } else if (source === "user-table-project") {
      navigate(-1);
    } else if (source === "users-list") {
      navigate("/organization/user-management", {
        state: {
          pageNo: location.state?.pageNo,
          searchTerm: location.state?.searchTerm,
          filterData: location.state?.filterData,
        },
      });
    } else {
      navigate("/organization/user-management");
    }
  };
  return (
    <div className="px-4 sm:px-6 md:px-6 lg:px-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6 w-full">
      {/* Breadcrumb */}
      <div className="flex flex-wrap justify-end text-xs font-light gap-1 h-5 sm:gap-2">
        <p>Home</p>
        <span>/</span>
        <p>Projects</p>
        <span>/</span>
        <TextStyles style={{ color: "#06513D" }}>User Detail Page</TextStyles>
      </div>

      {/* Title & Back Icon */}
      <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        <IoArrowBackCircleOutline
          onClick={handleBackNavigation}
          className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
        />
        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
          User Detail Page
        </div>
      </div>

      {/* User Details */}
      <div className="mt-1 w-full bg-[#fff] border border-[#3BA2B959] rounded-[10px] shadow-[0px_0px_16px_0px_#3BA2B91F]">
        {/* <div  className=" bg-[#fff] flex justify-center items-center border border-[#3BA2B959] rounded-[10px]  shadow-[0px_0px_16px_0px_#3BA2B91F]">
         */}
        <UserDetails onUserDataReceived={handleUserDataReceived} />

        {/* </div> */}
      </div>

      {/* Assigned Form */}
      <div className="mt-5 w-full">
        <AssignedForm formAllotments={formAllotments} employeeId={userId} />
      </div>
    </div>
  );
};

export default UserDetailPage;
